import {Component, Input} from '@angular/core';
import {CartService} from "../../../core/services/cart.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.css']
})
export class ItemComponent {
  @Input() cartData:any[] = [];

  constructor(private cartService: CartService, private router: Router) {
  }

  manageQty(item: any, type: string) {
    if (type == 'plus') this.cartService.addToCart(item);
    if (type == 'minus') this.cartService.updateCartItemQuantity(item.itemId, item.quantity - 1);
    if (type == 'remove') this.cartService.removeFromCart(item.itemId);
    if (type == 'remove-warranty') this.cartService.removeFromCart(item.itemId, type);
    this.cartService.cart$.subscribe((cart) => {
      this.cartData = cart;
    });
  }

  calculateDiscount(item: any) {
    if (item.mrp && item.mop) {
      const discount = Math.round(((item.mrp - item.mop) / item.mrp) * 100);
      return parseFloat(discount.toFixed(2))+'% off';
    }
  }

  navigateTo(item: any) {
    this.router.navigateByUrl(`/product/${item.catalogItemId}`);
  }
}
